import { ApplicationConfig, APP_INITIALIZER, provideZoneChangeDetection } from '@angular/core';
import { DEFAULT_LANGUAGE } from './commons/constants';
import { environment } from '../environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideTranslateService } from '@ngx-translate/core';
import { routes } from './app.routes';
import { appHttpInterceptor } from './interceptors/app-http.interceptor';
import { SwaggerAuthService } from './shared/lib/swagger-auth/services/auth.service';

/**
 * Initialize Swagger authentication configuration
 */
function initializeSwaggerAuth(
  authService: SwaggerAuthService
): () => void {
  return () => {
    // Configure auth service with environment settings
    authService.configure({
      apiUrl: environment.apiUrl,
      swaggerUrl: environment.swaggerUrl,
      loginPageUrl: environment.angularAppUrl + '/ui/login',
      authEndpoint: '/auth',
      showNotifications: true,
      branding: {
        platformName: environment.title || 'Swagger Documentation',
        subtitle: 'Please sign in to access the API documentation',
        companyName: 'MM Guide',
        logoUrl: environment.logoSrc || ''
      },
      cookieSettings: {
        name: 'SwaggerAuthToken',
        secure: environment.production,
        sameSite: 'lax',
        path: '/'
      }
    });
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([appHttpInterceptor])),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: "./assets/i18n/",
        suffix: ".json"
      }),
      fallbackLang: environment.defaultLanguage ?? DEFAULT_LANGUAGE
    }),
    SwaggerAuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeSwaggerAuth,
      deps: [SwaggerAuthService],
      multi: true
    }
  ]
};